/*
 * PF Comparateur — Entrée 1 (fiche produit, pilote Gants de boxe).
 * Ouvre un drawer de comparaison à partir de nœuds de données pré-rendus en Liquid.
 * Contraintes : aucun listener sur les formulaires d'achat, aucun appel /cart/add.
 * Les prix sont déjà rendus côté serveur (B2B correct) : le JS ne fait que cloner leur HTML.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('pf-cmp-config');
  var drawer = document.getElementById('pf-cmp-drawer');
  var tableHost = document.getElementById('pf-cmp-table');
  if (!configEl || !drawer || !tableHost) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

  var lastFocus = null;
  // Attributs techniques (sous les pastilles et l'avis). 'stock' est cloné en
  // HTML (rendu Liquid) ; les autres en texte avec « — » si vide.
  var SPEC_ROWS = ['matiere', 'rembourrage', 'fermeture', 'tailles', 'marque', 'stock'];

  // Re-parente le drawer sur <body> : les transforms transitoires des animations
  // du thème re-scopent position:fixed sur la section au lieu du viewport.
  document.body.appendChild(drawer);

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function dataNode(handle) {
    var nodes = document.querySelectorAll('.pf-cmp-data');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-handle') === handle) return nodes[i];
    }
    return null;
  }

  function specText(node, spec) {
    var el = node.querySelector('[data-spec="' + spec + '"]');
    return el ? el.textContent.trim() : '';
  }

  // Clone le HTML rendu par notre Liquid (pastilles, stock) — déjà échappé côté serveur.
  function specHtml(node, spec) {
    var el = node.querySelector('[data-spec="' + spec + '"]');
    return el ? el.innerHTML.trim() : '';
  }

  function dash(v) { return v && v.length ? esc(v) : '—'; }

  // Rangée de pastilles : cellule vide si le champ du produit est vide
  // (jamais de « — » sur les pastilles) ; rangée absente si les deux le sont.
  function chipsRow(label, l, r) {
    if (!l && !r) return '';
    return '<tr class="pf-cmp-rowlabel"><td colspan="2">' + esc(label) + '</td></tr>' +
           '<tr class="pf-cmp-rowvals pf-cmp-rowvals--chips">' +
             '<td>' + l + '</td>' +
             '<td>' + r + '</td>' +
           '</tr>';
  }

  function headerCell(node) {
    var thumb = node.querySelector('.pf-cmp-node-thumb');
    var price = node.querySelector('.pf-cmp-node-price');
    var available = node.getAttribute('data-available') === 'true';
    var html = '<div class="pf-cmp-th">';
    html += '<div class="pf-cmp-th__thumb">' + (thumb ? thumb.innerHTML : '') + '</div>';
    if (!available) {
      html += '<span class="pf-cmp-badge-soldout">' + esc(config.soldOut) + '</span>';
    }
    html += '<div class="pf-cmp-th__title">' + esc(node.getAttribute('data-title')) + '</div>';
    html += '<div class="pf-cmp-th__price">' + (price ? price.innerHTML : '') + '</div>';
    html += '</div>';
    return html;
  }

  function adviceCell(node) {
    var label = specText(node, 'avis-label');
    var text = specText(node, 'avis-text');
    if (!text) return '';
    return '<div class="pf-cmp-advice">' +
             '<span class="pf-cmp-advice__label">' + esc(label) + '</span>' +
             '<p class="pf-cmp-advice__text">' + esc(text) + '</p>' +
           '</div>';
  }

  function buildTable(leftHandle, rightHandle) {
    var left = dataNode(leftHandle);
    var right = dataNode(rightHandle);
    if (!left || !right) return false;

    var h = '<table class="pf-cmp-table">';

    // En-têtes collants : photo + nom + prix
    h += '<thead><tr>' +
           '<th scope="col">' + headerCell(left) + '</th>' +
           '<th scope="col">' + headerCell(right) + '</th>' +
         '</tr></thead>';

    h += '<tbody>';

    // 1) Pastilles de pertinence : usage puis niveau, juste sous l'en-tête.
    h += chipsRow(config.labels.usage, specHtml(left, 'usage-chips'), specHtml(right, 'usage-chips'));
    h += chipsRow(config.labels.niveau, specHtml(left, 'niveau-chip'), specHtml(right, 'niveau-chip'));

    // 2) Attributs techniques.
    SPEC_ROWS.forEach(function (spec) {
      var lv, rv;
      if (spec === 'stock') {
        lv = specHtml(left, spec) || '—';
        rv = specHtml(right, spec) || '—';
      } else {
        lv = dash(specText(left, spec));
        rv = dash(specText(right, spec));
      }
      h += '<tr class="pf-cmp-rowlabel"><td colspan="2">' + esc(config.labels[spec]) + '</td></tr>';
      h += '<tr class="pf-cmp-rowvals">' +
             '<td>' + lv + '</td>' +
             '<td>' + rv + '</td>' +
           '</tr>';
    });

    // 3) Ligne d'avis (crème) : tout en bas de la colonne (amendement 4/07).
    var la = adviceCell(left), ra = adviceCell(right);
    if (la || ra) {
      h += '<tr class="pf-cmp-rowvals pf-cmp-rowvals--advice">' +
             '<td>' + (la || '') + '</td>' +
             '<td>' + (ra || '') + '</td>' +
           '</tr>';
    }

    // CTA par colonne : Voir le produit (jamais d'ajout panier)
    h += '<tr class="pf-cmp-rowvals pf-cmp-rowvals--cta">' +
           '<td><a class="pf-cmp-view" href="' + esc(left.getAttribute('data-url')) + '">' + esc(config.viewProduct) + '</a></td>' +
           '<td><a class="pf-cmp-view" href="' + esc(right.getAttribute('data-url')) + '">' + esc(config.viewProduct) + '</a></td>' +
         '</tr>';

    h += '</tbody></table>';

    // Pont fiche → collection : produit courant pré-coché (même clé localStorage
    // que l'Entrée 2). Rendu seulement si le Liquid a fourni l'URL (B2C).
    if (config.moreUrl && config.moreLabel) {
      h += '<div class="pf-cmp-more"><a href="' + esc(config.moreUrl) + '" data-pf-more>' + esc(config.moreLabel) + '</a></div>';
    }

    tableHost.innerHTML = h;
    return true;
  }

  function focusable() {
    return drawer.querySelectorAll('a[href], button:not([disabled])');
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusable();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('pf-cmp-open');
    document.addEventListener('keydown', onKey);
    tableHost.scrollTop = 0;
    var closeBtn = drawer.querySelector('.pf-cmp-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.hidden = true;
    document.body.classList.remove('pf-cmp-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Délégation : ne réagit qu'aux éléments du comparateur, jamais au formulaire d'achat.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pf-compare]');
    if (btn) {
      e.preventDefault();
      var target = btn.getAttribute('data-pf-target');
      if (buildTable(config.current, target)) openDrawer();
      return;
    }
    var more = e.target.closest('[data-pf-more]');
    if (more) {
      // Pré-coche le produit courant pour l'Entrée 2, puis navigation normale.
      try { localStorage.setItem('pf_cmp_selection', JSON.stringify([config.current])); } catch (err) {}
      return;
    }
    if (e.target.closest('[data-pf-close]')) { closeDrawer(); }
  });
})();
